import React from 'react';
import styled from 'styled-components';
import InsightCard from '../molecules/InsightCard';
import { Insight } from '../../types/insight';

interface InsightListProps {
  insights: Insight[];
  onLike: (id: string) => void;
  onComment: (id: string) => void;
  onPin: (id: string) => void;
  onShare: (id: string) => void;
}

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  gap: 32px;
`;

const InsightList: React.FC<InsightListProps> = ({
  insights,
  onLike,
  onComment,
  onPin,
  onShare
}) => {
  return (
    <ListContainer>
      {insights.map(insight => (
        <InsightCard
          key={insight.id}
          insight={insight}
          onLike={onLike}
          onComment={onComment}
          onPin={onPin}
          onShare={onShare}
        />
      ))}
    </ListContainer>
  );
};

export default InsightList;
